function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { getProfilePath } from '@finect/front-core/Profiles';
import { withTheme } from 'styled-components';
import { Icon } from '../../Icon';
import { EntityCard } from '../../EntityCard';
import { IconBlock } from './partials';
export var AuthorIcon = function AuthorIcon(_ref) {
  var author = _ref.author,
    _ref$withEntityCard = _ref.withEntityCard,
    withEntityCard = _ref$withEntityCard === void 0 ? false : _ref$withEntityCard,
    _ref$withLink = _ref.withLink,
    withLink = _ref$withLink === void 0 ? false : _ref$withLink,
    theme = _ref.theme;
  var _author$features = author.features,
    features = _author$features === void 0 ? [] : _author$features;
  var path = getProfilePath(theme, author);
  var href = path.pattern.match ? path.path : path.superPartnerURL;
  var blockProps = withLink ? author.subtype === 'user' ? features.includes('profile') ? {
    as: 'a',
    href: href
  } : {} : {
    as: 'a',
    href: href
  } : {};
  var IconComponent = function IconComponent() {
    return React.createElement(IconBlock, blockProps, React.createElement(Icon, {
      size: 0,
      alt: author.displayName,
      image: author.icon ? "/image/".concat(author.icon) : null,
      margin: "0 8px 0 0",
      verified: author.isProfessional,
      withBorder: true
    }));
  };
  if (withEntityCard) {
    return React.createElement(EntityCard, {
      type: "profile",
      entity: _objectSpread(_objectSpread({}, author), {}, {
        icon: author.image,
        name: author.displayName
      })
    }, React.createElement(IconComponent, null));
  }
  return React.createElement(IconComponent, null);
};
export default React.memo(withTheme(AuthorIcon));